import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ACCESS_KEY = "my-access-token";
const REFRESH_KEY = "my-refresh-token";

axios.defaults.withCredentials = true;

export const storeTokens = (data) => {
  if (data?.access_token) localStorage.setItem(ACCESS_KEY, data.access_token);
  if (data?.refresh_token) localStorage.setItem(REFRESH_KEY, data.refresh_token);
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};

export const stripTokens = (data) => {
  const { access_token, refresh_token, ...user } = data || {};
  return user;
};

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_KEY);
  if (token && config.url?.startsWith(API)) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshing = null;

const refreshAccess = () => {
  if (!refreshing) {
    refreshing = axios
      .post(`${API}/auth/refresh`, { refresh_token: localStorage.getItem(REFRESH_KEY) || "" }, { _skipRetry: true })
      .then((r) => {
        storeTokens(r.data);
        return r.data.access_token;
      })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
};

axios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config || {};
    const isAuthRoute = /\/auth\/(login|register|refresh|session|logout)$/.test(config.url || "");
    if (error.response?.status !== 401 || config._skipRetry || isAuthRoute || !config.url?.startsWith(API)) {
      return Promise.reject(error);
    }
    try {
      await refreshAccess();
      return axios({ ...config, _skipRetry: true });
    } catch {
      return Promise.reject(error);
    }
  }
);
